import React from 'react';
import Header from "./header/Header";
import Footer from "./footer/Footer";
import Company from "./company/Company";
import './App.css'
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./home/Home";
import ContactUs from "./contactus/ContactUs";
import Products from './products/Products';
import { Download } from './download/Download';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Header />
                <Switch>
                    <Route exact path="/">
                        <Home />
                    </Route>
                    <Route path="/company">
                        <Company />
                    </Route>
                    <Route path="/contact">
                        <ContactUs />
                    </Route>
                    <Route path="/products">
                        <Products />
                    </Route>
                    <Route path="/download">
                        <Download />
                    </Route>
                </Switch>
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
